import { DEFAULT_LANG, DEFAULT_LOCALE } from '@lib/constants'

// These are the locales that CMS knows how to handle (for preview/delivery pages)
export type Locale = 'en-US' | 'es-US'

// These are the languages CMS supports locally
export const CMS_SUPPORTED_LANGS = ['en', 'es'] as const

export type Lang = (typeof CMS_SUPPORTED_LANGS)[number]

export interface Language {
  lang: Lang
  defaultLang: Lang
  supportedLangs: Lang[]
  isDefaultLang: boolean
}

// Mapping for preview/delivery pages
const langToLocaleMap: Record<Lang, Locale> = {
  en: 'en-US',
  es: 'es-US',
}

// Derive supported locales from the map (for preview/delivery fallback)
export const CMS_SUPPORTED_LOCALES: Locale[] = CMS_SUPPORTED_LANGS.map((lang) => langToLocaleMap[lang])

// Converts lang to locale (for preview/delivery pages)
export const langToLocale = (lang: string | undefined): Locale => {
  if (!lang) {
    return DEFAULT_LOCALE
  }

  const normalized = lang.toLowerCase() as Lang
  return langToLocaleMap[normalized] || DEFAULT_LOCALE
}

// Extracts lang from locale (for all pages, including production)
export const extractLang = (locale: string | undefined): Lang => {
  if (!locale) {
    return DEFAULT_LANG
  }

  const extracted = locale.replace('_', '-').split('-')[0].toLowerCase()

  return (CMS_SUPPORTED_LANGS as readonly string[]).includes(extracted) ? (extracted as Lang) : DEFAULT_LANG
}
